import {createContext} from 'react';
import { useState, useEffect } from 'react';

export const ServerContext = createContext();

export const ServerProvider = ({ children }) => {
    const [server, setServer] = useState(() => {
      // Pega do localStorage no início
      const stored = localStorage.getItem('server');
      return stored ? JSON.parse(stored) : null;
    });
  
    useEffect(() => {
      if (server !== null) {
        localStorage.setItem('server', JSON.stringify(server));
      }
    }, [server]);
  
    return (
      <ServerContext.Provider value={{ server, setServer }}>
        {children}
      </ServerContext.Provider>
    );
  };